module.exports = __webpack_public_path__ + "img/1280.0dcb6846.svg";